import { ErrorMessage, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { InputGroup } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl'
import Loader from '../../../components/Loader'
import ModelComponent from '../../../components/Modal'
import TextError from '../../../components/TextError'
import { customStyles } from '../../../components/customStyles'
import { callApi, decodeId, showToast } from '../../../lib/AllGlobalFunction'
import { redirectTo } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _childMenuImg_ } from '../../../lib/ImagePath'
import { _alphabetRegex_, _integerRegex_ } from '../../../lib/Regex'
import { _exception } from '../../../lib/exceptionMessage'

const ChildMenuForm = ({
  modalShow,
  setModalShow,
  editData,
  setEditData,
  toast,
  setToast,
  fetchData
}) => {
  const [searchParams] = useSearchParams()
  const encodedId = searchParams.get('id')
  const id = encodedId ? decodeId(encodedId) : null
  const [dropDownData, setDropDownData] = useState()
  const [loading, setLoading] = useState(false)
  const [allState, setAllState] = useState()
  const [initialValues, setInitialValues] = useState()
  const location = useLocation()
  const { userId } = useSelector((state) => state?.user?.userInfo)

  const fetchDropDownData = async (
    endpoint,
    queryString = '?pageindex=0&PageSize=0',
    setterFunc
  ) => {
    setLoading(true)
    await axiosProvider({
      method: 'GET',
      endpoint,
      queryString
    })
      .then((res) => {
        setLoading(false)
        if (res.status === 200 && res?.data?.data) {
          return setterFunc(res?.data?.data)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (editData) {
      let endpoint = ''
      switch (editData?.redirectTo) {
        case 'Product List':
          endpoint = 'MainCategory/getEndCategory'
          break

        case 'Static Page':
          endpoint = 'ManageStaticPages'
          break

        case 'Landing Page':
          endpoint = 'LendingPage'
          break

        case 'Collection Page':
          endpoint = 'ManageCollection'
          break

        default:
          break
      }
      endpoint &&
        fetchDropDownData(endpoint, '?pageindex=0&PageSize=0', (data) => {
          setDropDownData(data)
        })

      if (endpoint?.includes('MainCategory')) {
        const fetchData = async () => {
          try {
            setLoading(true)
            let apiUrls = []
            apiUrls.push({
              endpoint: 'Brand',
              queryString: '?pageindex=0&PageSize=0',
              state: 'brand'
            })
            const assignSpecificationData = await callApi(
              'AssignSpecificationToCategory/getByCatId',
              `?catId=${editData?.categoryId}`
            )

            if (assignSpecificationData?.isAllowColors) {
              apiUrls.push({
                endpoint: 'Color/search',
                queryString: '?pageindex=0&PageSize=0',
                state: 'color'
              })
            }
            if (assignSpecificationData?.isAllowSize) {
              apiUrls.push({
                endpoint: 'AssignSizeValuesToCategory/byAssignSpecId',
                queryString: `?assignSpecId=${assignSpecificationData?.id}&pageindex=0&PageSize=0`,
                state: 'sizeType'
              })
            }
            const fetchData = async () => {
              let sizeType, color, brand

              const responses = await fetchAllGenericData(apiUrls)
              responses.forEach((response) => {
                switch (response.state) {
                  case 'sizeType':
                    sizeType = response.data
                    break

                  case 'color':
                    color = response?.data
                    break

                  case 'brand':
                    brand = response?.data

                  default:
                    break
                }
              })
              setLoading(false)
              setAllState({
                ...allState,
                sizeType,
                color,
                brand
              })
              setInitialValues(prepareEditData(brand, sizeType, color))
            }
            fetchData()
          } catch (error) {
            setLoading(false)
          }
        }
        fetchData()
      } else {
        setInitialValues(prepareEditData())
      }
    } else {
      setInitialValues({
        headerId: id,
        name: '',
        redirectTo: '',
        categoryId: 0,
        staticPageId: 0,
        lendingPageId: 0,
        collectionId: 0,
        customLink: '',
        hasLink: false,
        sequence: '',
        menuType: 'Custom',
        imageAlt: ''
      })
    }
  }, [editData])

  const fetchAllGenericData = async (apiUrls) => {
    try {
      const responseArray = await Promise.all(
        apiUrls.map((url) => callApi(url.endpoint, url.queryString, url.state))
      )

      return responseArray
    } catch (error) {}
  }

  const getIdName = (values) => {
    let idName = ''
    switch (values?.redirectTo) {
      case 'Product List':
        idName = 'categoryId'
        break

      case 'Static Page':
        idName = 'staticPageId'
        break

      case 'Landing Page':
        idName = 'lendingPageId'
        break

      case 'Collection Page':
        idName = 'collectionId'
        break

      default:
        break
    }

    return idName
  }

  const onSubmit = async (values, { setFieldValue }) => {
    const submitFormData = new FormData()
    let val = { ...values }
    let endpoint = 'ManageChildMenu'
    val = {
      Brands: values?.brands?.map((brand) => brand.id).join(',') ?? '',
      MenuType: values?.menuType,
      HeaderId: values?.headerId,
      Name: values?.name,
      ImageFile: values?.imageFile ? values?.imageFile : '',
      Image: values?.imageFile
        ? values?.imageFile.name
        : values?.image
        ? values?.image
        : '',
      ImageAlt: values?.imageAlt ?? '',
      HasLink: values?.hasLink ?? '',
      RedirectTo: values?.redirectTo,
      LendingPageId: values?.lendingPageId ?? 0,
      CategoryId: values?.categoryId ?? 0,
      StaticPageId: values?.staticPageId ?? 0,
      CollectionId: values?.collectionId ?? 0,
      CustomLink: values?.customLink ?? '',
      Sequence: values?.sequence,
      Sizes: values?.sizes?.map((size) => size.id).join(',') ?? '',
      Colors: values?.colors?.map((color) => color.id).join(',') ?? '',
      ParentId: modalShow?.parentId,
      IsImageAvailable: values?.imageFile || values?.image ? true : false
    }

    if (values?.id) {
      val = { ...val, Id: values?.id }
    }

    const keys = Object.keys(val)

    keys.forEach((key) => {
      submitFormData.append(key, val[key])
    })

    try {
      let method = values?.id ? 'PUT' : 'POST'

      setLoading(true)
      const response = await axiosProvider({
        method,
        endpoint,
        data: val.menuType === 'CategoryWise' ? val : submitFormData,
        logData: values,
        location: location?.pathname,
        userId
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        fetchData()
        setModalShow({
          ...modalShow,
          show: !modalShow.show,
          isDataUpdated: true
        })
      }

      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const prepareEditData = (brand = null, sizeType = null, color = null) => {
    let data = editData
    switch (editData?.redirectTo) {
      case 'Product List':
        data = { ...editData, dropDownId: 'categoryId' }
        break

      case 'Static Page':
        data = { ...editData, dropDownId: 'staticPageId' }
        break

      case 'Landing Page':
        data = { ...editData, dropDownId: 'lendingPageId' }
        break

      case 'Collection Page':
        data = { ...editData, dropDownId: 'collectionId' }
        break

      default:
        break
    }
    if (editData?.brands) {
      let brandIds = editData?.brands.split(',').map(Number)
      brandIds = brand
        .filter((item) => brandIds.includes(item.id))
        .map((item) => ({ name: item.name, id: item.id }))
      data = { ...data, brands: brandIds }
    }
    if (editData?.colors) {
      let colorIds = editData?.colors.split(',').map(Number)
      colorIds = color
        .filter((item) => colorIds.includes(item.id))
        .map((item) => ({ name: item.name, id: item.id }))
      data = { ...data, colors: colorIds }
    }

    if (editData?.sizes) {
      let sizeIds = editData?.sizes.split(',').map(Number)
      sizeIds = sizeType
        .filter((item) => sizeIds.includes(item.sizeId))
        .map((item) => ({ name: item.sizeName, id: item.sizeId }))
      data = { ...data, sizes: sizeIds }
    }
    return { ...data, imageAlt: data?.imageAlt ?? '' }
  }

  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png']

  const validationSchema = Yup.object().shape(
    {
      name: Yup.string()
        .matches(_alphabetRegex_, 'Only alphabet allowed')
        .required('Please enter name'),
      hasLink: Yup.boolean(),
      sequence: Yup.string().required('Sequence is required'),
      redirectTo: Yup.string().when('hasLink', {
        is: (hasLink) => hasLink === true,
        then: () => Yup.string().required('Redirect to required'),
        otherwise: () => Yup.string().nullable()
      }),
      categoryId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Product List',
        then: () =>
          Yup.number()
            .moreThan(0, 'Product list required')
            .required('Product list required'),
        otherwise: () => Yup.string().nullable()
      }),
      staticPageId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Static Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Static page required')
            .required('Static page required'),
        otherwise: () => Yup.string().nullable()
      }),
      lendingPageId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Landing Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Landing page required')
            .required('Landing page required'),
        otherwise: () => Yup.string().nullable()
      }),
      collectionId: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Collection Page',
        then: () =>
          Yup.number()
            .moreThan(0, 'Collection page required')
            .required('Collection page required'),
        otherwise: () => Yup.string().nullable()
      }),
      customLink: Yup.string().when('redirectTo', {
        is: (redirectTo) => redirectTo === 'Other Links',
        then: () => Yup.string().required('Other link required'),
        otherwise: () => Yup.string().nullable()
      }),
      imageFile: Yup.mixed().when('menuType', {
        is: (menuType) => menuType === 'Custom',
        then: () =>
          Yup.mixed().when('imageFile', {
            is: (value) => value?.name,
            then: (schema) =>
              schema
                .test(
                  'fileFormat',
                  'File formate is not supported, Please use .jpg/.png/.jpeg format support',
                  (value) => value && SUPPORTED_FORMATS.includes(value.type)
                )
                .test('fileSize', 'File must be less than 2MB', (value) => {
                  return value !== undefined && value && value.size <= 2000000
                }),
            otherwise: (schema) => schema.nullable()
          }),
        otherwise: () => Yup.string().nullable()
      })
    },
    ['imageFile', 'imageFile']
  )

  return (
    <ModelComponent
      show={modalShow.show}
      modalsize={'md'}
      modalheaderclass={''}
      className='modal-backdrop'
      modeltitle={'Manage Child Menu'}
      onHide={() => {
        setEditData()
        setModalShow({ ...modalShow, show: !modalShow.show })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
      formbuttonid='subMenu'
      footerClass={'d-none'}
    >
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form id='subMenu' className='manage_banner_modal'>
            {loading && <Loader />}
            <div className='row'>
              <div className='row'>
                <div className='col-md-3'>
                  <div className='input-file-wrapper m--cst-filetype mb-3'>
                    <label className='form-label d-block' htmlFor='logo'>
                      Image
                    </label>
                    <input
                      id='filename'
                      className='form-control'
                      name='logo'
                      type='file'
                      accept='image/jpg, image/png, image/jpeg'
                      onChange={(event) => {
                        const objectUrl = URL.createObjectURL(
                          event.target.files[0]
                        )
                        if (event.target.files[0].type !== '') {
                          setFieldValue('image', objectUrl)
                        }
                        setFieldValue(
                          'imageFile',
                          event?.target?.files[0] ? event?.target?.files[0] : ''
                        )
                      }}
                      hidden
                    />
                    {values?.image ? (
                      <div className='position-relative m--img-preview d-flex rounded-2 overflow-hidden'>
                        <img
                          src={
                            values?.image?.includes('blob')
                              ? values?.image
                              : `${process.env.REACT_APP_IMG_URL}${_childMenuImg_}${values?.image}`
                          }
                          alt='Preview Image'
                          title={values?.image ? values?.imageFile?.name : ''}
                          className='rounded-2'
                        ></img>
                        <span
                          onClick={(e) => {
                            setFieldValue('image', null)
                            setFieldValue('imageFile', '')
                            document.getElementById('filename').value = null
                          }}
                        >
                          <i className='m-icon m-icon--close'></i>
                        </span>
                      </div>
                    ) : (
                      <>
                        <label
                          className='m__image_default d-flex align-items-center justify-content-center rounded-2'
                          htmlFor='filename'
                        >
                          <i className='m-icon m-icon--defaultpreview'></i>
                        </label>
                      </>
                    )}
                    <ErrorMessage
                      name='imageFile'
                      component={TextError}
                      customclass={'cfz-12 lh-sm'}
                    />
                  </div>
                </div>
                <div className='col-md-9'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='input-file-wrapper mb-3'>
                        <FormikControl
                          control='input'
                          label='Name'
                          isRequired
                          id='name'
                          type='text'
                          name='name'
                          placeholder='Name'
                          onChange={(e) => {
                            const inputValue = e?.target?.value
                            const fieldName = e?.target?.name
                            const isValid = _alphabetRegex_.test(inputValue)
                            if (isValid || !inputValue)
                              setFieldValue([fieldName], inputValue)
                          }}
                          onBlur={(e) => {
                            let fieldName = e?.target?.name
                            setFieldValue(fieldName, values[fieldName]?.trim())
                          }}
                        />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <FormikControl
                        label='Image Alt'
                        control='input'
                        type='text'
                        name='imageAlt'
                        placeholder='Image Alt'
                        onChange={(e) => {
                          setFieldValue('imageAlt', e?.target?.value)
                        }}
                        onBlur={(e) => {
                          let fieldName = e?.target?.name
                          setFieldValue(fieldName, values[fieldName]?.trim())
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <FormikControl
                        isRequired
                        control='input'
                        label='Sequence'
                        type='number'
                        name='sequence'
                        onChange={(e) => {
                          const inputValue = e?.target?.value
                          const isValid = _integerRegex_.test(inputValue)
                          const fieldName = e?.target?.name
                          if (isValid || !inputValue)
                            setFieldValue([fieldName], inputValue)
                        }}
                        placeholder='Sequence'
                        onBlur={(e) => {
                          let fieldName = e?.target?.name
                          setFieldValue(fieldName, values[fieldName]?.trim())
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className='col-md-4 mt-auto mb-3'>
                  <label className='form-label'>Link</label>
                  <InputGroup className='custom_checkbox'>
                    <InputGroup.Checkbox
                      id='hasLink'
                      name='hasLink'
                      checked={values?.hasLink}
                      onChange={(e) => {
                        if (!e?.target?.checked) {
                          setFieldValue('redirectTo', '')
                          setFieldValue('categoryId', 0)
                          setFieldValue('lendingPageId', 0)
                          setFieldValue('staticPageId', 0)
                          setFieldValue('collectionId', 0)
                        }
                        setFieldValue('hasLink', e?.target?.checked)
                      }}
                    />
                    <label className='custom_label' htmlFor='hasLink'>
                      Has Link
                    </label>
                  </InputGroup>
                </div>

                <div className='col-md-8'>
                  {values?.hasLink && (
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label required'>Redirect To</label>
                      <Select
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        id='redirectTo'
                        placeholder='Redirect To'
                        defaultValue={
                          !editData
                            ? null
                            : {
                                value: values.redirectTo,
                                label: values.redirectTo
                              }
                        }
                        options={redirectTo}
                        onChange={(e) => {
                          setFieldValue('categoryId', 0)
                          setFieldValue('lendingPageId', 0)
                          setFieldValue('staticPageId', 0)
                          setFieldValue('collectionId', 0)
                          setFieldValue('customLink', '')
                          let endpoint = ''
                          switch (e?.value) {
                            case 'Product List':
                              setFieldValue('dropDownId', 'categoryId')
                              endpoint = 'MainCategory/getEndCategory'
                              break

                            case 'Static Page':
                              setFieldValue('dropDownId', 'staticPageId')
                              endpoint = 'ManageStaticPages'
                              break

                            case 'Landing Page':
                              setFieldValue('dropDownId', 'lendingPageId')
                              endpoint = 'LendingPage'
                              break

                            case 'Collection Page':
                              setFieldValue('dropDownId', 'collectionId')
                              endpoint = 'ManageCollection'
                              break

                            default:
                              break
                          }
                          endpoint &&
                            fetchDropDownData(
                              endpoint,
                              '?pageindex=0&PageSize=0',
                              (data) => {
                                setDropDownData(data)
                              }
                            )
                          setFieldValue('redirectTo', e?.value)
                        }}
                      />
                      <ErrorMessage name='redirectTo' component={TextError} />
                    </div>
                  )}
                </div>
                {values?.redirectTo && (
                  <>
                    <div className='col-md-12'>
                      <div className='input-file-wrapper mb-3'>
                        {values?.redirectTo === 'Other Links' ? (
                          <>
                            <FormikControl
                              control='input'
                              label={values?.redirectTo}
                              isRequired
                              id='customLink'
                              type='text'
                              name='customLink'
                              placeholder='Custom Link'
                              onChange={(e) => {
                                setFieldValue('categoryId', 0)
                                setFieldValue('lendingPageId', 0)
                                setFieldValue('staticPageId', 0)
                                setFieldValue('collectionId', 0)
                                setFieldValue('customLink', e?.target?.value)
                              }}
                              onBlur={(e) => {
                                let fieldName = e?.target?.name
                                setFieldValue(
                                  fieldName,
                                  values[fieldName]?.trim()
                                )
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <label className='form-label required'>
                              {values?.redirectTo && values?.redirectTo}
                            </label>
                            <Select
                              styles={customStyles}
                              menuPortalTarget={document.body}
                              id='clist'
                              placeholder={values?.redirectTo}
                              value={
                                dropDownData &&
                                values?.[values?.dropDownId] && {
                                  value: dropDownData?.filter(
                                    (data) =>
                                      data?.id === values?.[values?.dropDownId]
                                  )[0]?.id,
                                  label: values?.redirectTo
                                    .toLowerCase()
                                    .includes('product')
                                    ? dropDownData?.filter(
                                        (data) =>
                                          data?.id ===
                                          values?.[values?.dropDownId]
                                      )[0]?.pathNames
                                    : dropDownData?.filter(
                                        (data) =>
                                          data?.id ===
                                          values?.[values?.dropDownId]
                                      )[0]?.name
                                }
                              }
                              options={
                                dropDownData &&
                                dropDownData?.map(
                                  ({ id, name, pathNames }) => ({
                                    value: id,
                                    label: values?.redirectTo
                                      .toLowerCase()
                                      .includes('product')
                                      ? pathNames
                                      : name
                                  })
                                )
                              }
                              onChange={(e) => {
                                setAllState()
                                setFieldValue('brands', [])
                                setFieldValue('colors', [])
                                setFieldValue('sizes', [])
                                setFieldValue('categoryId', 0)
                                setFieldValue('lendingPageId', 0)
                                setFieldValue('staticPageId', 0)
                                setFieldValue('collectionId', 0)
                                const fetchData = async () => {
                                  try {
                                    setLoading(true)
                                    let apiUrls = []
                                    const data = await callApi(
                                      'AssignSpecificationToCategory/getByCatId',
                                      `?catId=${e?.value}`
                                    )
                                    apiUrls.push({
                                      endpoint: 'Brand',
                                      queryString: '?pageindex=0&PageSize=0',
                                      state: 'brand'
                                    })
                                    if (data?.isAllowColors) {
                                      apiUrls.push({
                                        endpoint: 'color',
                                        queryString: '?pageindex=0&PageSize=0',
                                        state: 'color'
                                      })
                                    }
                                    if (data?.isAllowSize) {
                                      apiUrls.push({
                                        endpoint:
                                          'AssignSizeValuesToCategory/byAssignSpecId',
                                        queryString: `?assignSpecId=${data?.id}&pageindex=0&PageSize=0`,
                                        state: 'sizeType'
                                      })
                                    }
                                    setFieldValue('assiCategoryId', data?.id)

                                    const fetchData = async () => {
                                      let sizeType, color, brand

                                      const responses =
                                        await fetchAllGenericData(apiUrls)
                                      responses.forEach((response) => {
                                        switch (response.state) {
                                          case 'sizeType':
                                            sizeType = response.data
                                            break

                                          case 'brand':
                                            brand = response.data
                                            break

                                          case 'color':
                                            color = response?.data
                                            break

                                          default:
                                            break
                                        }
                                      })

                                      setAllState({
                                        ...allState,
                                        sizeType,
                                        brand,
                                        color
                                      })
                                      setLoading(false)
                                    }
                                    fetchData()
                                  } catch (error) {
                                    setLoading(false)
                                  }
                                }

                                values?.redirectTo === 'Product List' &&
                                  fetchData()

                                switch (values?.redirectTo) {
                                  case 'Product List':
                                    setFieldValue('categoryId', e?.value)
                                    break

                                  case 'Static Page':
                                    setFieldValue('staticPageId', e?.value)
                                    break

                                  case 'Landing Page':
                                    setFieldValue('lendingPageId', e?.value)
                                    break

                                  case 'Collection Page':
                                    setFieldValue('collectionId', e?.value)
                                    break

                                  default:
                                    break
                                }
                              }}
                            />
                            <ErrorMessage
                              name={getIdName(values)}
                              component={TextError}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {allState?.brand && (
                  <div className='col-md-12'>
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label'>Select Brand</label>
                      <Select
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        id='brands'
                        isClearable
                        isMulti
                        placeholder='Select Brand'
                        value={
                          values?.brands &&
                          values.brands?.map((data) => {
                            return {
                              label: data?.name,
                              value: data?.id
                            }
                          })
                        }
                        options={
                          allState?.brand &&
                          allState?.brand?.map(({ id, name }) => ({
                            value: id,
                            label: name
                          }))
                        }
                        onChange={(e) => {
                          let brands = values?.brands ?? []
                          brands = e?.map((data) => {
                            return { name: data?.label, id: data.value }
                          })
                          setFieldValue('brands', brands)
                        }}
                      />
                    </div>
                  </div>
                )}
                {allState?.sizeType && (
                  <div className='col-md-6'>
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label'>Select Size</label>
                      <Select
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        id='sSize'
                        isMulti
                        isClearable
                        placeholder='Select Size'
                        value={
                          values?.sizes &&
                          values?.sizes?.map((data) => {
                            return {
                              label: data?.name,
                              value: data?.id
                            }
                          })
                        }
                        options={
                          allState?.sizeType &&
                          allState?.sizeType?.map(({ sizeId, sizeName }) => ({
                            value: sizeId,
                            label: sizeName
                          }))
                        }
                        onChange={(e) => {
                          let sizes = values?.sizes ?? []
                          sizes = e?.map((data) => {
                            return {
                              name: data?.label,
                              id: data?.value
                            }
                          })
                          setFieldValue('sizes', sizes)
                        }}
                      />
                    </div>
                  </div>
                )}
                {allState?.color && (
                  <div className='col-md-6'>
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label'>Select Color</label>
                      <Select
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        id='sColor'
                        isClearable
                        placeholder='Select Color'
                        isMulti
                        value={
                          values?.colors &&
                          values.colors?.map((data) => {
                            return {
                              label: data?.name,
                              value: data?.id
                            }
                          })
                        }
                        options={
                          allState?.color &&
                          allState?.color?.map(({ id, name }) => ({
                            value: id,
                            label: name
                          }))
                        }
                        onChange={(e) => {
                          let colors = values?.colors ?? []
                          colors = e?.map((data) => {
                            return { name: data?.label, id: data?.value }
                          })
                          setFieldValue('colors', colors)
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ModelComponent>
  )
}

export default ChildMenuForm
